import { createSelector } from '@reduxjs/toolkit';

const partnerObject = (state = {}) => state.sellers;

export const getLoading = createSelector(
  partnerObject,
  (groupData) => groupData.ui.loading,
);

export const getSellers = createSelector(
  partnerObject,
  (groupData) => groupData.sellers,
);

export const getSellersProducts = createSelector(
  partnerObject,
  (groupData) => groupData.data,
);
export const getSellersLocations = createSelector(
  partnerObject,
  (groupData) => groupData.delivery,
);
export const getPageStats = createSelector(
  partnerObject,
  (groupData) => groupData.ui.stats,
);

export const getSellerId = createSelector(
  partnerObject,
  (partnerObject) => partnerObject.partner,
);

export const getLocation = createSelector(
  partnerObject,
  (partnerObject) => partnerObject.ui.location,
);

export const getCategories = createSelector(
  partnerObject,
  (groupData) => groupData.categories,
);

export const getLoadingProducts = createSelector(
  partnerObject,
  (partnerObject) => partnerObject.ui.loadingProducts,
);
